import React from 'react';
import Modal from 'react-modal';
import { FaLock, FaShieldAlt } from 'react-icons/fa';
import './SecureModeConfirmModal.css';

if (typeof document !== 'undefined' && document.getElementById('root')) {
  Modal.setAppElement('#root');
}

function formatRupeeLabel(amountInPaise) {
  const rupees = amountInPaise / 100;
  return rupees.toLocaleString('en-IN', {
    maximumFractionDigits: rupees % 1 === 0 ? 0 : 2,
  });
}

function SecureModeConfirmModal({
  isOpen,
  onCancel,
  onConfirm,
  baseAmountInPaise,
  secureAmountInPaise,
  description,
}) {
  const secureLabel = formatRupeeLabel(secureAmountInPaise);
  const baseLabel = formatRupeeLabel(baseAmountInPaise);
  const feeChanged = Number(secureAmountInPaise) !== Number(baseAmountInPaise);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      contentLabel="Secure Mode Confirmation"
      className="secure-confirm-modal"
      overlayClassName="secure-confirm-overlay"
      closeTimeoutMS={180}
    >
      <div className="secure-confirm-header">
        <div className="secure-confirm-icon" aria-hidden="true">
          <FaLock />
        </div>
      </div>
      <div className="secure-confirm-body">
        <h2>Secure Mode is on</h2>
        <p className="secure-confirm-lead">{description}</p>
        <div className="secure-confirm-note">
          <FaShieldAlt aria-hidden="true" />
          <span>Manual review happens before any nominee is notified.</span>
        </div>
        <div className="secure-confirm-fee">
          <span className="secure-confirm-fee-label">Verification fee</span>
          <strong>₹{secureLabel}</strong>
          {feeChanged ? (
            <span className="secure-confirm-fee-was">Standard fee ₹{baseLabel}</span>
          ) : null}
        </div>
        <div className="secure-confirm-actions">
          <button type="button" className="secure-confirm-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="secure-confirm-pay" onClick={onConfirm}>
            Continue &amp; Pay ₹{secureLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default SecureModeConfirmModal;
